import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import LoginForm from "./components/LoginForm";
import TrustBadges from "./components/TrustBadges";


const LoginScreen = () => {
  const { isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  // Redirect already-authenticated users to dashboard
  useEffect(() => {
    if (!loading && isAuthenticated) {
      navigate("/volunteer-dashboard", { replace: true });
    }
  }, [isAuthenticated, loading, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <svg className="animate-spin w-8 h-8 text-primary" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
          </svg>
          <p className="text-sm text-muted-foreground">Loading…</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Top bar */}
      <header className="w-full px-6 py-4 flex items-center justify-between border-b border-border bg-white">
        <Link to="/" className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
            <span className="text-white font-bold text-sm">LPS</span>
          </div>
          <span className="font-semibold text-foreground text-sm hidden sm:block">Volunteer Portal</span>
        </Link>
        <Link
          to="/volunteer-registration"
          className="text-sm text-primary font-medium hover:text-primary/80 transition-colors"
        >
          New volunteer? Register here
        </Link>
      </header>

      {/* Main content */}
      <main className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          {/* Card */}
          <div className="bg-white rounded-2xl shadow-sm border border-border p-8">
            {/* Heading */}
            <div className="mb-8">
              <h1
                className="text-2xl font-bold text-foreground mb-1.5"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                Welcome back
              </h1>
              <p className="text-sm text-muted-foreground">
                Sign in to access your volunteer dashboard and training resources.
              </p>
            </div>

            {/* Form */}
            <LoginForm />

            {/* Trust badges */}
            <TrustBadges />
          </div>

          {/* Register link (mobile-friendly below card) */}
          <p className="text-center text-sm text-muted-foreground mt-6">
            Don't have an account?{" "}
            <Link
              to="/volunteer-registration"
              className="text-primary font-medium hover:text-primary/80 transition-colors"
            >
              Register here
            </Link>
          </p>
        </div>
      </main>
    </div>
  );
};

export default LoginScreen;
